import React from "react";
import {
  CopyrightSection,
  FooterContent,
  Logo,
  LogoContainer,
  StyledFooter,
} from "./Footer.styled";

import LogoMd from "../../assets/logo.png";
import SocialNetworks from "../Header/SocialNetworks/SocialNetworks";
import { Box } from "@mui/material";
import FooterNav from "./FooterNav/FooterNav";
import { footerNavigationConstants } from "../../constants/navigationConstants";
import { Trans, useTranslation } from "react-i18next";
import { Copyright } from "@mui/icons-material";

const Footer: React.FC = () => {
  const { t } = useTranslation();
  return (
    <StyledFooter>
      <FooterContent>
        <LogoContainer>
          <Logo>
            <img src={LogoMd} alt="BP Consulting Logo" height={89} />
          </Logo>
        </LogoContainer>
        <FooterNav links={footerNavigationConstants} />
      </FooterContent>
      <CopyrightSection>
        <Box>
          <Trans
            t={t}
            i18nKey="footer.copyright"
            components={[
              <a
                href="https://www.tremium.net"
                target="_blank"
                rel="noopener noreferrer"
              />,
              <Copyright fontSize={"inherit"} />,
            ]}
          />
        </Box>
        <SocialNetworks></SocialNetworks>
        <Box>
          <Trans
            t={t}
            i18nKey="footer.copyrightDesign"
            components={[
              <a
                href="https://www.freepik.com"
                target="_blank"
                rel="noopener noreferrer"
              />,
              <Copyright fontSize={"inherit"} />,
            ]}
          />
        </Box>
      </CopyrightSection>
    </StyledFooter>
  );
};

export default Footer;
